import { render, staticRenderFns } from "./ComfyStyleManager.vue?vue&type=template&id=65525f4b&scoped=true"
import script from "./ComfyStyleManager.vue?vue&type=script&lang=js"
export * from "./ComfyStyleManager.vue?vue&type=script&lang=js"
import style0 from "./ComfyStyleManager.vue?vue&type=style&index=0&id=65525f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65525f4b",
  null
  
)

export default component.exports